export default "__VITE_ASSET__C_aFXU3i__"